import './banner';
import './blog';
import './achievements';
import './jobs';
import './contact-popup';
import './header-fixed';
import './gallery';
import './scroll';